'use client';

import { ReactNode } from 'react';

import { usePathname } from '~/i18n/routing';

interface CartPageHiderProps {
  children: ReactNode;
}

export function CartPageHider({ children }: CartPageHiderProps) {
  const pathname = usePathname();
  const isCartPage = pathname === '/cart' || pathname === '/cart/';

  if (isCartPage) return null;

  return children;
}
